<template>
    <div v-if="field">
        <b-input-group> <b-input-group-prepend>
                <b-dropdown id="ddown1" :text="defaultLocale">
                    <b-dropdown-item @click="localeEditor = true"> Edit </b-dropdown-item>
                    <b-dropdown-item v-for="locale in allLocales" :key="locale" @click="currentLocale = locale">{{ locale }}</b-dropdown-item>
                </b-dropdown>
            </b-input-group-prepend>

            <b-form-input 
                type="text" 
                :id="field.key" 
                :placeholder="constraints.placeholder"
                v-model="content"
                autocomplete="off"
                v-bind="$attrs"
            ></b-form-input>
           

            <b-form-invalid-feedback :id="field.key" style="display:block" v-if="allErrors !== undefined && allErrors.length > 0">
                {{ translateExtendedError(allErrors[0]) || null }}
            </b-form-invalid-feedback>

            <b-form-invalid-feedback :id="field.key" style="display:block" v-else>
                {{ errors[0] || null }}
            </b-form-invalid-feedback>

         </b-input-group>

         <b-sidebar title="Locales" right :visible="localeEditor">
            <div class="px-3 py-2">
                 <b-form-group
                    label="Locale:"
                    label-for="locale:"
                    :label-cols="3"
                    :horizontal="true">
                 <v-select multiple :options="availableLocales" v-model="allLocales"></v-select>
                </b-form-group>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
import locales from '../locales.json'
import vSelect from 'vue-select'

export default {
    name: "IdentityField_Texti18n",
    components: {
        vSelect
    },
    props: {
        field: {
            type: Object
        },

        value: {
            type: Object,
            default: () => {
                return {
                    locales: {}
                }
            }
        },

        extendErrors: {
            type: Array
        },

        store: {
            type: Object
        },

        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: [],
            errorTrans: {
                email_already_exists: "Email already exists",
                unique: "This field must be unique",
                invalid: "Invalid value"
            },
            currentLocale: null,
            availableLocales: [],
            localeEditor: false
        }
    },
    computed: {
        content: {
            get() {
                try {
                    if (!this.value) {
                        let value = {
                            locales: {}
                        }

                        value.locales[this.defaultLocale] = ""
                    }

                    return this.value.locales[this.defaultLocale]
                } catch {
                    return this.value
                }
            },

            set(val) {
                let v = this.value || {
                    locales: {}
                }

                try {
                    v.locales[this.defaultLocale] = val
                } catch(err) {
                     v = {
                        locales: {}
                    }
                    
                    v.locales[this.defaultLocale] = val
                }

                this.$emit('input', v)
                this.check(v)
            }
        },
        constraints() {
            let constr = this.field.constraints || {}

            return constr
        },

        customData() {
            let { custom_data = {} } = this.constraints || {}
            let { texti18n } = custom_data || {}

            if (texti18n) {
                return texti18n
            }

            return {
                default_locale: 'en_US'
            }
        },

        allErrors: {
            get() {
                return this.extendErrors
            },

            set(val) {
                this.errors = val
            }   
        },

        defaultLocale() {
            return this.currentLocale || this.customData.default_locale || this.storage.getters.getLocale
        },

        allLocales: {
            get() {
                try {
                    let locales = Object.keys(this.value.locales)
                    if (locales.length > 0) {
                        return locales
                    }

                    return [this.defaultLocale]
                } catch(err) {
                    return [this.defaultLocale]
                }
            },

            set(val) {
                let nVal = {}

                nVal[this.defaultLocale] = this.value.locales[this.defaultLocale]
                val.forEach(k => {
                    nVal[k] = this.value.locales[k]
                })

                this.$emit('input', {locales: nVal})
            }
        },

        storage: {
            get() {
                return this.store || this.$store
            }
        }
    },
    watch: {
        content: function(val) {
            this.check(val)
        }
    },
    methods: {
        check(v) {
            let value = v || this.value

            if (value) {
                Object.keys(value.locales || []).forEach(k => {
                    let val = value.locales[k] || ""

                    this.errors = []
                    this.allErrors = []

                    if (val == "" && this.constraints.required) {
                        this.errors.push(this.translator("identityField.requiredField"))
                    }
                    
                    if (this.constraints.length !== undefined) {
                        if (this.constraints.length.max !== null && this.constraints.length.max > 0) {
                            if (val.length > this.constraints.length.max && val.length > 0) {
                                this.errors.push(
                                    this.translator("identityField.cantBeMoreThenChars", {
                                        max: this.constraints.length.max
                                    })
                                )
                            }
                        }
                        
                        if (this.constraints.length.min !== null) {
                            if (val.length < this.constraints.length.min && val.length > 0) {
                                this.errors.push(
                                    this.translator("identityField.cantBeLessThenChars", {
                                        min: this.constraints.length.min
                                    })
                                )  
                            }
                        }
                    }

                    if (this.constraints.not_allowed_words !== undefined) {
                        let notAllowedWords = this.constraints.not_allowed_words.split(",")
                        notAllowedWords.forEach(word => {
                            word = word.trim()

                            if (word != "") {
                                if (val.indexOf(word) !== -1) {
                                    if (word.length < 2) {
                                        this.errors.push(
                                            this.translator("identityField.symbolNotAllowed", {
                                                symbol: word
                                            })
                                        )
                                    } else {
                                        this.errors.push(
                                            this.translator("identityField.wordNotAllowed", {
                                                word: word
                                            })
                                        )
                                    }
                                    
                                }  
                            }              
                        })
                    }

                    if (this.constraints.regex !== undefined || this.constraints.regex !== "") {
                        let re = new RegExp(this.constraints.regex)
                        if (! re.test(val)) {
                            this.errors.push(this.translator("identityField.invalidInput"))
                        }
                    }
                        
                    this.$emit("error", {field: this.field.key, error: this.errors.length > 0 || this.extendErrors.length})
                })
            }
        },

        translateExtendedError(err) {
            return this.errorTrans[err] || err
        },

        newLocaleInput(e) {
            this.content.locales[e] = ""
        }
    },
    mounted() {
        if (this.constraints.default && this.content === null) {
            this.content = this.constraints.default
            return
        }

        this.check(this.content)

        this.availableLocales = Object.keys(locales)
    }
}
</script>